import {Component, input, InputSignal, ChangeDetectionStrategy} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-loading-spinner',
    imports: [TranslateModule],
    templateUrl: './loading-spinner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./loading-spinner.component.css']
})
export class LoadingSpinnerComponent {
    public loadingText: InputSignal<string | undefined> = input<string | undefined>(undefined);
}
